import toastr from 'toastr';

window.toastr = toastr;

// Initialize toastr
toastr.options = {
    closeButton: true,
    progressBar: true,
    positionClass: "toast-top-right",
    timeOut: 3000
};
